export const frontendUrl = "https://kabelschacht-int.hsig.ch"

export const apiUrls = {
  authenticationService: "https://kabelschacht-int-auth.hsig.ch",
  userEndpoint: "https://kabelschacht-int-auth.hsig.ch/user",
  releaseNotesEndpoint: "https://kabelschacht-int-auth.hsig.ch/releaseNote.php",
  plansEndpoint: "https://kabelschacht-int-proj.hsig.ch/plans",
  planOwnerEndpoint: "https://kabelschacht-int-proj.hsig.ch/changeowner",
  projectsEndpoint: "https://kabelschacht-int-proj.hsig.ch/projects",
  deliveryAddressEndpoint: "https://kabelschacht-int-proj.hsig.ch/deliveryaddress.php",
  billingAddressEndpoint: "https://kabelschacht-int-proj.hsig.ch/billingaddress.php",
  projectStatusEndpoint: "https://kabelschacht-int-proj.hsig.ch/changestatus",
  planPdfDownload: "https://kabelschacht-int-proj.hsig.ch/pdfs.php",
  detailsEndpoint: "https://kabelschacht-int-proj.hsig.ch/detail.php",
  armouringDataEndpoint: "https://kabelschacht-int-proj.hsig.ch/armouring.php",
  armouringDocumentsEndpoint: "https://mannhart-test-armouring-factory.hsig.app",
  vaultElementInfoEndpoint: "https://kabelschacht-int-proj.hsig.ch/vaultelementinfo.php"
}

export const mannhartWebsite = "https://mannhart.swiss"
export const termsAndConditions = "https://mannhart.swiss"
export const privacyPolicy = "https://mannhart.swiss"
export const releaseNotes = "https://mannhart.swiss/kabelschacht-app-versionen"
